var map = {
	"./Mini.png": 71,
	"./SpentAll.png": 72,
	"./TFE.png": 73,
	"./breathe.png": 74,
	"./email.svg": 75,
	"./facebook.svg": 76,
	"./github.svg": 77,
	"./hong-kong.svg": 78,
	"./joe.png": 79,
	"./linkedin.svg": 80,
	"./monitor_400.gif": 24,
	"./monitor_800.gif": 21,
	"./portfolio_500.gif": 23,
	"./portfolio_800.gif": 18,
	"./priorities.svg": 81,
	"./skills.svg": 82,
	"./tele.png": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;